import img01 from "../../images/chapters/04/list/01.jpg";
import img02 from "../../images/chapters/04/list/02.jpg";
import img03 from "../../images/chapters/04/list/03.jpg";
import img04 from "../../images/chapters/04/list/04.jpg";
import img05 from "../../images/chapters/04/list/05.jpg";
import img06 from "../../images/chapters/04/list/06.jpg";
import img07 from "../../images/chapters/04/list/07.jpg";
import img08 from "../../images/chapters/04/list/08.jpg";
import img09 from "../../images/chapters/04/list/09.jpg";
import img10 from "../../images/chapters/04/list/10.jpg";
import img11 from "../../images/chapters/04/list/11.jpg";
import img12 from "../../images/chapters/04/list/12.jpg";
import img13 from "../../images/chapters/04/list/13.jpg";
import img14 from "../../images/chapters/04/list/14.jpg";
import img15 from "../../images/chapters/04/list/15.jpg";
import img16 from "../../images/chapters/04/list/16.jpg";
import img17 from "../../images/chapters/04/list/17.jpg";
import img18 from "../../images/chapters/04/list/18.jpg";
import img19 from "../../images/chapters/04/list/19.jpg";
import img20 from "../../images/chapters/04/list/20.jpg";

export const captions = [
  "Close-up of scoop and hammer in MESA",
  "Close-up of TV camera mounted on MESA",
  "Side view of MESA (Note the TV camera aimed at forward leg to record ladder descent and first step on lunar surface.)",
  "View of MESA on Lunar Module mockup-up",
  "Mating of the Apollo 11 Spacecraft to the Saturn V launch vehicule.",
  "The S-II second stage is moved into position for mating with the S-IC first stage",
  "The S-IVB third stage is moved into position for mating.",
  "A crane lists the S-IC stage in preparation for stacking on a mobile launch within the Vehicle Assembly Building’s High Bay 1.",
  "Workers prepare the S-IVB for mating of the Instrument Unit, which houses guidance, control and other Saturn V systems",
  "The Apollo 11 Command / Service Module (CSM-107) being readied for transfer to the Vehicle Assembly Building.",
  "The Apollo 11 CMS is mated to the spacecraft adapter.",
  "Workers prepare the S-IC first stage in the transfer aisle of the Vehicule Assembly Building.",
  "Aerial view of Apollo 11 rollout",
];

export const list = [
  { img: img01 },
  { img: img02 },
  { img: img03 },
  { img: img04 },
  { img: img05 },
  { img: img06 },
  { img: img07 },
  { img: img08, caption: captions[0] },
  { img: img09 },
  { img: img10 },
  { img: img11 },
  { img: img12 },
  { img: img13 },
  { img: img14, caption: captions[1] },
  { img: img15 },
  { img: img16 },
  { img: img17 },
  { img: img18 },
  { img: img19 },
  { img: img20, caption: captions[2] },
];
